module.exports = __webpack_public_path__ + "static/img/06bg.9a198c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/01home/06bg.png
// module id = J20S
// module chunks = 0